module.exports = __webpack_public_path__ + "463b3d53ece4fba169915ad42988357f.png";